/**
 * Formats license plate numbers to have proper spacing between letters and numbers
 * Example: "ABC123" becomes "ABC 123"
 */
// THE way a plate is shown everywhere (owner, 6 Oct 2026: "لازم السيارة فى اى مكان فى البرنامج تظهر الحروف ومسافة
// والارقام"): its letters, one space, its digits - "DD82408" / "dd-82408" / "J/96735" -> "DD 82408" / "J 96735"; any
// other spelling ("DXB P 12345", digits only) as it is with single spaces. For showing only: matching keys stay
// letters+digits. The engine's twin: fines_pipeline.normalization.plate_text.
export const formatPlateNumber = (plateNumber) => {
    if (plateNumber === null || plateNumber === undefined) return '';
    const plate = String(plateNumber).trim().toUpperCase().replace(/\s+/g, ' ');
    const m = /^([A-Z]{1,3})[\s\-/]*(\d{1,6})$/.exec(plate);
    return m ? `${m[1]} ${m[2]}` : plate;
};